import React from 'react'
import { ButtonClose, ButtonLogin, ButtonRegister, Container, ForgotPassword, Form, InputItem, RegisterOption } from './LoginElements'
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import logo from '../../assets/images/escudo-mb.svg';

const FormLogin = ({handleClose, handleChange, error, form, loading, handleSubmit, showRegister, olvidoClave}) => {
  const [t] = useTranslation('global');

  return (
    <Container>
          <ButtonClose onClick={handleClose}>
            <CloseIcon/>
          </ButtonClose>
          <Form autoComplete="off">
            <img src={logo} alt='logo' />
            <h3>{t('login.log-in')}</h3>
            <div>
              <InputItem value={form.user}>
                <input type='text' required name='user' value={form.user} onChange={handleChange} className={error.user ? 'error' : null} />
                <label>{t('login.username')}</label>
                {error.user && <p className='error'><InfoIcon/> {error.user}</p>}
              </InputItem>
              <InputItem value={form.password}>
                <input type='password' required name='password' value={form.password} onChange={handleChange} className={error.password ? 'error' : null} />
                <label>{t('login.password')}</label>
                {error.password && <p className='error'><InfoIcon/> {error.password}</p>}
                {error.intentosFallidos && <p className='error' style={{marginTop: '0.5rem'}}><InfoIcon/> {error.intentosFallidos}</p>}
              </InputItem>
              <ButtonLogin type='submit' disabled={loading} onClick={handleSubmit}>{loading ? t('deposit.loading') : t('login.log-in')}</ButtonLogin>
              <ForgotPassword onClick={olvidoClave}>{t('login.forgot-password')}</ForgotPassword>
            </div>
          </Form>
          <RegisterOption>
            <p>{t('login.not-account')}</p>
            <ButtonRegister onClick={showRegister}>{t('login.register')}</ButtonRegister>
          </RegisterOption>
        </Container>
  )
}

export default FormLogin